import { render, staticRenderFns } from "./OrgDetailsModal.vue?vue&type=template&id=d9a0e7d4"
import script from "./OrgDetailsModal.vue?vue&type=script&lang=js"
export * from "./OrgDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports